import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PlatformLocation, isPlatformBrowser } from '@angular/common';

import { LandingPageService } from '../services/landingpage.service';
import { Router } from '@angular/router';
declare var jQuery: any;
@Component({
  selector: 'app-searchbar',
  templateUrl: './searchbar.component.html',
  styleUrls: ['./searchbar.component.css']
})
export class SearchbarComponent implements OnInit {
  title = 'Cruize';
  locations: any[] = [];
  cruiseLines: any[] = [];
  place: string = "";
  cruiseLine: any = '';
  cruiseAvailability: {};
  exclusiveDeals: any[] = [];
  sailMonths: any[] = [];
  sailDate: any = "";
  duration: any = ""; public loginType = '';

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private landingPageService: LandingPageService, private toastr: ToastrService,
    private router: Router) {

    if (isPlatformBrowser(this.platformId)) {
      if (!sessionStorage.getItem("loginType")) {
        sessionStorage.setItem("loginType", "B2C"); this.loginType = "B2C";
      } else { this.loginType = sessionStorage.getItem("loginType") }
    }
  }

  ngOnInit() {
    this.getCruiseLines();
    this.getSailMonths();
  }
  makeItBlank(event) {
    jQuery(event.target).val("");
  }
  getLocations(event) {
    this.place = event.target.value;
    if (this.place.length > 2)
      this.landingPageService.getLocations(this.place).subscribe(
        data => {
          let resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
          if (resp.locations) {
            this.locations = resp.locations;
          }
        },
        error => {
          console.log(error);
        }
      )
  }

  getCruiseLines() {
    this.landingPageService.getCruiseLines().subscribe(
      data => {
        let resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
        if (resp.cruiseLine) {
          this.cruiseLines = resp.cruiseLine;
        }
      },
      error => {
        console.log(error);
      }
    )
  }

  getCruiseAvailability() {
    // Added one more index for the Cruise
    if (!this.cruiseLine && !this.place) {
      this.toastr.warning("Please Select At Least Cuiseline or Destination...!")
      return false;
    }
    var data = ""; var qstring = "";
    if (this.sailDate) {
      data = this.place + "()" + this.sailDate.month + "()" + this.duration + "()";
      qstring = this.place + "---" + this.sailDate.month + "---" + this.duration;
    } else {
      data = this.place + "()()" + this.duration + "()";
      qstring = this.place + "---" + "" + "---" + this.duration;
    }
    if (this.cruiseLine != '') {
      data = data + this.cruiseLine.CruiseLine + "()";
      qstring = qstring + "---" + this.cruiseLine.CruiseLine.split(' ').join('-');
    } else { qstring = qstring + "---"; }

    // This last index for Cruise Code
    qstring = qstring + "---";

    if (!this.sailDate && !this.place && !this.duration && this.cruiseLine.CruiseLine) {
      qstring = this.cruiseLine.CruiseLine.split(' ').join('-');
      this.router.navigate(["/" + qstring.toLowerCase()]);
    }
    // if (!this.sailDate && !this.duration && !this.cruiseLine && this.place) {
    //   qstring = this.place + "-cruises";
    //   this.router.navigate(["/" + qstring.toLowerCase()]);
    // } else {
    //   this.router.navigate(["availbility/" + qstring.toLowerCase()]);
    // }

    this.router.navigate(["availbility/" + qstring.toLowerCase()]);
  }

  getSailMonths() {
    this.landingPageService.getSailMonths().subscribe(
      data => {
        let resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
        if (resp.status == 'success') {
          this.sailMonths = resp.months;
        }
      },
      error => {
        console.log(error);
      }
    )
  }

  setLocation(loc) {
    this.place = loc;
    this.locations = [];
  }

  setSailMonths() {

  }

}

